module.exports = __webpack_public_path__ + "static/img/1-1.630a31a.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/7/1/14/eng/1-1.png
// module id = 4tBS
// module chunks = 0